module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/object/define-property.js
// module id = 35
// module chunks = 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 46 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68